// eslint-disable-next-line @typescript-eslint/no-namespace
export class Statistics {
    static calculateWinPercentage(winTotal: number, total: number) : string {
        return (winTotal*100/(total*1 || 1)).toFixed(2).replace(".", ",") + "%";
    }
}